import PropTypes from 'prop-types';
import React from 'react';

import './Checkbox.css';
export default class Checkbox extends React.Component {

  componentWillMount() {
    this.defaultName = 'checkbox_' + Math.ceil(Math.random() * 10000);
  }

  /* Latest checkbox js*/
  render() {
    let { isDocCheck, style, defaultChecked, checked, name, className, lblClassName, lblText, linkText, linkClass, ariaLabelledby, ariaLabelledbytext, ariadescribedby, ariaLabel } = this.props;
    name = !!name ? name : this.defaultName;
    if (isDocCheck === true && isDocCheck !== undefined) {
      return (
        <div className={'checkbox__container ' + className}>
          <input aria-describedby={ariadescribedby}
            id={name}
            name={name}
            ref={c => this.input = c}
            className='gdocs-checkbox'
            aria-label={ariaLabel}
            style={style}
            type="checkbox"
            role={this.props.role}
            disabled={this.props.disabled}
            defaultChecked={defaultChecked}
            onChange={this._onChange.bind(this)} />
          <label className={'gdocs-checkbox__label ' + lblClassName} role={this.props.role} htmlFor={name} aria-labelledby={`${ariaLabelledbytext} ${ariaLabelledby}`}>
            <span className="tick-mark" id={ariaLabelledbytext}></span>
            {lblText} {linkText !== undefined ? <a href='#' className={linkClass} id={ariaLabelledby} tabindex="0" onClick={this.props.handLinkeClick}>{linkText}</a> : ''}
          </label>
        </div>
      )
    }
    else {
      return this.props.controlled ? (
        <div className={'checkbox__container ' + className}>
          <input aria-describedby={ariadescribedby}
            id={name}
            name={name}
            className='checkbox__input'
            aria-label={ariaLabel}
            style={style}
            type="checkbox"
            disabled={this.props.disabled}
            checked={checked}
            role={this.props.role}
            maxLength={this.props.textMaxLength !== undefined ? this.props.textMaxLength : 10}
            onChange={this._onChange.bind(this)}
            tabIndex={this.props.tabIndex}
          />
          <label className='checkbox__label' htmlFor={name} role={this.props.role}>
            <span className='checkbox__checkmark'></span>
          </label>
        </div>
      ) : (
          <div className={'checkbox__container ' + className}>
            <input aria-describedby={ariadescribedby}
              id={name}
              name={name}
              ref={c => this.input = c}
              className='gdocs-checkbox'
              aria-label={ariaLabel}
              style={style}
              type="checkbox"
              disabled={this.props.disabled}
              role={this.props.role}
              defaultChecked={defaultChecked}
              // checked={checked}
              onChange={this._onChange.bind(this)}
            />
            <label className={'gdocs-checkbox__label ' + lblClassName} role={this.props.role} htmlFor={name} aria-labelledby={`${ariaLabelledbytext} ${ariaLabelledby}`}>
              <span className="tick-mark" id={ariaLabelledbytext}></span>
              {lblText} {linkText !== undefined ? <a href='#' className={linkClass} id={ariaLabelledby} tabindex="0" onClick={this.props.handLinkeClick}>{linkText}</a> : ''}
            </label>
          </div>
      )
    }

  }

  _onChange(evt) {
    this.props.onChange(evt);
  }

}

Checkbox.defaultProps = {
  className: '',
  checked: false,
  defaultChecked: false,
  style: {},
  disabled: false
}

Checkbox.propTypes = {
  onChange: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/common/Checkbox/Checkbox.js